import Noty, { Options } from 'noty';
import { i18n } from '@/main';

export default class BPCMessageService {
  public currentMessages = [];

  public defaultConfig: Options = {
    layout: 'topRight',
    timeout: 5000,
    theme: 'relax',
  };

  public showSuccessMessage(config: Options) {
    const successConfig: Options = {
      type: 'success',
    };
    const finalConfig = {
      ...config,
      ...successConfig,
      ...this.defaultConfig,
    };
    this.showMessage(finalConfig);
  }

  public showInfoMessage(config: Options) {
    const infoConfig: Options = {
      type: 'info',
    };
    const finalConfig = {
      ...config,
      ...infoConfig,
      ...this.defaultConfig,
    };
    this.showMessage(finalConfig);
  }

  public showWarningMessage(config: Options) {
    const warningConfig: Options = {
      type: 'warning',
    };
    const finalConfig = {
      ...config,
      ...warningConfig,
      ...this.defaultConfig,
    };
    this.showMessage(finalConfig);
  }

  public showErrorMessage(config: Options) {
    const errorConfig: Options = {
      type: 'error',
    };
    const finalConfig = {
      ...config,
      ...errorConfig,
      ...this.defaultConfig,
    };
    this.showMessage(finalConfig);
  }
  public showMessage(config: Options) {
    const key = config.text;
    config.text = String(i18n.t(config.text));
    const index = this.currentMessages.indexOf(key);
    if (index <= -1) {
      this.currentMessages.push(key);
      new Noty(config).show();
      setTimeout(() => {
        this.currentMessages.splice(index, 1);
      }, Number(this.defaultConfig.timeout));
    }
  }
}

export const useMessageService = (): BPCMessageService => {
  return new BPCMessageService();
};
